import { Divider, Flex } from "@chakra-ui/react";
import { Chart } from "react-google-charts";
import SiteLinks from "../site-links/SiteLinks";

const FooterLeft = (): JSX.Element => {
  const data = [
    ["Country", "Country"],
    ["India", "India"],
  ];

  return (
    <Flex
      width={"400px"}
      maxWidth={"100%"}
      direction={"column"}
      alignItems={"center"}
      gap={3}
    >
      <Chart
        chartType={"GeoChart"}
        data={data}
        width={"100%"}
        height={"auto"}
        legendToggle={false}
        options={{
          backgroundColor: "transparent",
          datalessRegionColor: "#e8e8e9",
          defaultColor: "#319795",
        }}
      />
      <Divider marginY={3} width={"50%"} borderColor={"gray.600"} />
      <SiteLinks />
    </Flex>
  );
};

export default FooterLeft;
